// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeUsernameCheckBody = {
  username: string;
};

export type typeUsernameCheckOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    isAvailable: boolean;
    normalizedUsername: string;
    unavailableReason?: "taken" | "invalidFormat" | null;
  };
};

export type typeUsernameCheckOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUsernameCheckOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeUsernameCheckOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaUsernameCheckBody = {
  type: "object",
  properties: { username: { type: "string", maxLength: 3000, minLength: 1 } },
  required: ["username"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createUsernameCheck(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaUsernameCheckBody);
  }

  return async function postUsernameCheck(
    payload: typeUsernameCheckBody,
  ): Promise<typeUsernameCheckOutput200 | typeUsernameCheckOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postUsernameCheck" failed before calling the network. #921716c3cf83`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#921716c3cf83" },
        },
        data: null,
      } as typeUsernameCheckOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/username/check`,
      httpMethod: "POST",
      options,
    })) as typeUsernameCheckOutput200 | typeUsernameCheckOutput400;
  };
}
